import { create } from '@bufbuild/protobuf'
import { useMemo } from 'react'

import { useListControls } from '@/api/control.hook'
import { ListControlsRequestSchema } from '@/gen/inventory/v1/control_service_pb'
import { OngoingAssessment } from '@/gen/inventory/v1/ongoing_assessment_pb'

import { isResolvedControlStatus } from '@/lib/control-status'

/**
 * Whether every enabled control has been dealt with, so concluding the assessment raises no warning.
 * Not-applicable counts as dealt with — it was reviewed and taken out of scope deliberately.
 */
export const useIsAllControlValidated = (assessmentId?: OngoingAssessment['id']) => {
  const { data: controlsData } = useListControls({
    ...create(ListControlsRequestSchema, { assessmentId: assessmentId ?? '' }),
    enabled: !!assessmentId,
  })

  return useMemo(() => {
    if (!controlsData) return false
    return controlsData.every(
      ({ status, isEnabled }) => !isEnabled || isResolvedControlStatus(status),
    )
  }, [controlsData])
}
